import { render } from "./SharingButton.vue?vue&type=template&id=2513b956&scoped=true"
import script from "./SharingButton.vue?vue&type=script&lang=js"
export * from "./SharingButton.vue?vue&type=script&lang=js"

import "./SharingButton.vue?vue&type=style&index=0&id=2513b956&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2513b956"]])

export default __exports__